import { useCallback } from 'react'
import { useSetToast } from 'hooks'
import { logger, EventCategory } from 'utils/logger'
import { useTranslation } from 'react-i18next'
import { loggerSentry } from '@/utils/loggerSentry'

export const useErrorHandler = (componentName: string) => {
  const setToast = useSetToast()
  const { t } = useTranslation()
  const handleError = useCallback(
    (text: string, error: Error, icon: string = 'info') => {
      setToast({
        text: t('toast.apiError', {
          error: text || 'An unexpected error occurred',
        }),
        icon,
      })

      logger.error({
        message: `error_in_${componentName.toLowerCase().replace(/\s+/g, '_')}`,
        category: EventCategory.ERROR,
        error,
        data: {
          componentName,
          userMessage: text,
          errorDetails: {
            name: error?.name,
            message: error?.message,
            stack: error?.stack,
          },
        },
      })

      loggerSentry.error({
        message: `error_in_${componentName.toLowerCase().replace(/\s+/g, '_')}`,
        category: EventCategory.ERROR,
        error,
        data: {
          componentName,
          userMessage: text,
        },
      })

      console.error(`An error ocurred in ${componentName}`, error)
    },
    [setToast, componentName, t],
  )

  return handleError
}
